// extracted by mini-css-extract-plugin
module.exports = {"container":"invalidDRMLinkMessage_container__1ddvm","title":"invalidDRMLinkMessage_title__2tC3i","check":"invalidDRMLinkMessage_check__3w-aP"};